import { Membership } from '~/types/memberCustomerDirectorySession';

function getMembershipBySlagId(memberships: Membership[] | undefined, slagId: string) {
    return memberships?.find((m) => m.slagId === slagId);
}

export default getMembershipBySlagId;
